import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProneService } from '@app/prone-operations/services/prone.service';
import { AuthService } from '@auth/services/auth.service';
import { LoadingService } from '@common/services/loading.service';
import { finalize } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService =     inject(AuthService);
  const isPublic =          authService.isPublic()
  const loadingService =  inject(LoadingService);
  const proneService =    inject(ProneService);

  let authToken: string | undefined = undefined;
  let userLogged =  undefined;
  if (proneService.deviceConfig()) {

    // userLogged  = proneService.userLogged()??undefined;
    authToken   = proneService.proneToken() ? `pronew ${proneService.proneToken()}` : undefined;
  } else {
    userLogged =  isPublic ? undefined : authService.getUserLogged();
    const token = isPublic ? undefined : authService.getToken();
    authToken = token ? `Bearer ${token}` : undefined;
  }

  // if (proneService.deviceConfig()) {
  //   userLogged  = proneService.userLogged();
  //   authToken   = proneService.userLogged()!.token
  // } else {
  //   userLogged =  isPublic ? undefined : authService.getUserLogged();
  //   authToken =   isPublic ? undefined : authService.getToken(); // Obtén el token
  // }


  // Inicia el contador de carga
  loadingService.startLoading();

  // Clona la petición y añade la nueva cabecera
  let headers = req.headers;
  if (authToken) {
    headers = headers.set('Authorization', authToken);
  }
  if (userLogged?.company_id !== undefined && userLogged?.company_id !== null) {
    headers = headers.set('x-company-context', `${userLogged.company_id}`);
  }

  const authReq = req.clone({ headers });


  // Continúa el flujo y maneja la finalización de la petición
  return next(authReq).pipe(
    finalize(() => {
      // Detiene el contador de carga cuando la petición se completa o falla
      loadingService.stopLoading();
    })
  );
};
